import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "overflow-x-auto" }
const _hoisted_2 = { class: "w-full overflow-scroll table-auto" }
const _hoisted_3 = { class: "font-bold text-left capitalize border-b-2 border-black divide-x-2 divide-gray-400" }
const _hoisted_4 = {
  scope: "col",
  class: "w-64 px-2 py-2"
}
const _hoisted_5 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_6 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_7 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_8 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_9 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_10 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_11 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_12 = { class: "px-2 py-6 space-x-4 capitalize md:py-3 whitespace-nowrap md:whitespace-normal" }
const _hoisted_13 = { class: "px-2 py-2 capitalize whitespace-nowrap md:whitespace-normal" }
const _hoisted_14 = { class: "px-2 py-2 capitalize" }
const _hoisted_15 = { class: "px-2 py-2 capitalize whitespace-nowrap md:whitespace-normal" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "px-2 py-2 capitalize whitespace-nowrap md:whitespace-normal" }
const _hoisted_18 = { class: "px-2 py-2 capitalize" }
const _hoisted_19 = { class: "px-2 py-2 capitalize" }
const _hoisted_20 = { class: "px-2 py-2" }

import { Event } from "@/types";
import { deserializeSlug } from "@/utils/slugify";
import { PropType } from "vue";
import RoleGuard from "../RoleGuard.vue";
import { storeToRefs } from "pinia";
import { useUserStore } from "@/store";
import { shouldShowColumn } from "@/utils/events";


export default /*#__PURE__*/_defineComponent({
  __name: 'EventsTable',
  props: {
  events: {
    type: Array as PropType<Event[]>,
    required: true,
  },
},
  setup(__props) {



const { user } = storeToRefs(useUserStore());

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", _hoisted_3, [
          _createElementVNode("th", _hoisted_4, _toDisplayString(_ctx.$t("event-name")), 1),
          _createElementVNode("th", _hoisted_5, _toDisplayString(_ctx.$t("course-type")), 1),
          _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.$t("venue")), 1),
          _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.$t("delivery-date")), 1),
          _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.$t("trainer")), 1),
          _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t("attendees")), 1),
          _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t("training-status")), 1),
          _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t("actions")), 1)
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.events, (event) => {
          return (_openBlock(), _createElementBlock("tr", {
            class: "border-b border-gray-400 divide-x divide-gray-300",
            key: event.id
          }, [
            _createElementVNode("td", _hoisted_12, [
              _createElementVNode("span", null, _toDisplayString(event.name) + " (#" + _toDisplayString(event.id) + ")", 1)
            ]),
            _createElementVNode("td", _hoisted_13, _toDisplayString(_unref(shouldShowColumn)(_unref(user), event) ? _unref(deserializeSlug)(event.type) : "N/A"), 1),
            _createElementVNode("td", _hoisted_14, _toDisplayString(event.city ? event.city : _ctx.$t("online")), 1),
            _createElementVNode("td", _hoisted_15, [
              (event.template.delivery !== 'e-learning' && event.first_event_date)
                ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(new Date(event.first_event_date!).toLocaleDateString("en-GB", { year: "numeric", month: "long", day: "numeric" })), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("td", _hoisted_17, _toDisplayString(event.owner.first_name) + " " + _toDisplayString(event.owner.last_name), 1),
            _createElementVNode("td", _hoisted_18, [
              _createVNode(RoleGuard, { roles: ['admin', 'courses-admin', 'clubs-admin', 'users-admin'] }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(event.total_bookings), 1)
                ]),
                _: 2
              }, 1024),
              _createVNode(RoleGuard, { roles: ['trainer-organisation', 'facilitator-organisation', 'l4a-trainer'] }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(shouldShowColumn)(_unref(user), event) ? event.total_bookings : "N/A"), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            _createElementVNode("td", _hoisted_19, _toDisplayString(_unref(shouldShowColumn)(_unref(user), event) ? _ctx.$t(event.status) : "N/A"), 1),
            _createElementVNode("td", _hoisted_20, [
              _createVNode(_component_router_link, {
                to: `/dashboard/courses/events/${event.id}?tab=registered_attendees`,
                class: "text-blue"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("view")), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})